import { Col } from 'react-bootstrap';
import styled from 'styled-components';

export const SSection = styled.section`
  // margin: ${props => props.margin || '50px 0'};
  padding: ${props => (props.padding ? '5em 0' : 'unset')};
  //height: auto;

  position: relative;
  z-index: 0;
  background: #f5f7fb;
`;

export const SCol = styled(Col).attrs({ className: 'align-self-center' })`
  padding: 0;
`;

export const SContainer = styled.div.attrs(() => ({
  className: 'container-fluid',
}))``;

export const SRow = styled.div.attrs(() => ({
  className: 'justify-content-center mx-auto row',
}))``;

export const STitle = styled.div`
  text-align: center;
  padding-bottom: 30px;
  margin: 0 auto;
`;
